import { render, staticRenderFns } from "./df-error-card.vue?vue&type=template&id=b345de94"
import script from "./df-error-card.ts?vue&type=script&lang=js&external"
export * from "./df-error-card.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports